module.exports = __webpack_public_path__ + "static/media/smart-studio-bg-1.7b07e21f.jpg";